module.exports = new __parcel__URL__("rend.0ff0d5d1.png").toString();